class ShopifyVariantPopup {
    constructor() {
      this.productHandle = 'celluultimate';
      this.currentVariant = null;
      this.product = null;
      this.selectedOptions = {};
      
      this.initializePopup();
    }

    initializePopup() {
      const showBtn = document.getElementById('showVariantPopup');
      const overlay = document.getElementById('variantPopupOverlay');
      const content = document.getElementById('variantPopupContent');

      showBtn.addEventListener('click', () => {
        this.showPopup();
        this.loadProduct();
      });

      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          this.hidePopup();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && overlay.style.display === 'block') {
          this.hidePopup();
        }
      });
    }

    showPopup() {
      const overlay = document.getElementById('variantPopupOverlay');
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    hidePopup() {
      const overlay = document.getElementById('variantPopupOverlay');
      overlay.style.display = 'none';
      document.body.style.overflow = 'auto';
    }

    async loadProduct() {
      try {
        const response = await fetch(`/products/${this.productHandle}.js`);
        this.product = await response.json();
        this.renderProductOptions();
      } catch (error) {
        console.error('Error loading product:', error);
        this.renderError();
      }
    }

    renderProductOptions() {
      const content = document.getElementById('variantPopupContent');
      
      let html = `
        <div class="product-info">
          <img src="${this.product.featured_image}" alt="${this.product.title}" class="product-image">
          <h2>${this.product.title}</h2>
          <div class="product-price">€149,99</div>
          <h3>Selecionar cores</h3>
        </div>
      `;

      // Render option selectors
      this.product.options.forEach((option, index) => {
        html += `
          <div class="variant-option">
            <label>${option.name}:</label>
            <div class="variant-grid" data-option-index="${index}">
        `;

        option.values.forEach(value => {
          const isAvailable = this.isOptionValueAvailable(index, value);
          const isSelected = this.selectedOptions[index] === value;
          
          html += `
            <div class="variant-swatch ${isSelected ? 'selected' : ''} ${!isAvailable ? 'unavailable' : ''}" 
                 data-option-index="${index}" 
                 data-value="${value}"
                 ${isAvailable ? 'onclick="variantPopup.selectOption(' + index + ', \'' + value + '\')"' : ''}>
              ${value}
            </div>
          `;
        });

        html += `
            </div>
          </div>
        `;
      });

      // Add to cart button
      html += `
        <div class="popup-actions">
          <button class="add-to-cart-btn" id="addToCartBtn" onclick="variantPopup.addToCart()" disabled>
            Adicionar ao carrinho
          </button>
          <button class="close-popup-btn" onclick="variantPopup.hidePopup()">×</button>
        </div>
      `;

      content.innerHTML = html;
      
      // Initialize with first available variant
      this.initializeDefaultSelection();
    }

    initializeDefaultSelection() {
      // Select first available option for each option position
      this.product.options.forEach((option, index) => {
        const availableValue = option.values.find(value => 
          this.isOptionValueAvailable(index, value)
        );
        if (availableValue) {
          this.selectOption(index, availableValue);
        }
      });
    }

    selectOption(optionIndex, value) {
      this.selectedOptions[optionIndex] = value;
      
      // Update UI
      document.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(el => {
        el.classList.remove('selected');
      });
      
      const selectedEl = document.querySelector(`[data-option-index="${optionIndex}"][data-value="${value}"]`);
      if (selectedEl) {
        selectedEl.classList.add('selected');
      }

      // Find matching variant
      this.updateCurrentVariant();
      this.updatePrice();
      this.updateAddToCartButton();
    }

    updateCurrentVariant() {
      const selectedValues = Object.values(this.selectedOptions);
      
      this.currentVariant = this.product.variants.find(variant => {
        return variant.options.every((option, index) => 
          option === selectedValues[index]
        );
      });
    }

    updatePrice() {
      const priceEl = document.getElementById('selectedPrice');
      if (this.currentVariant && priceEl) {
        priceEl.textContent = this.formatPrice(this.currentVariant.price);
      }
    }

    updateAddToCartButton() {
      const btn = document.getElementById('addToCartBtn');
      if (this.currentVariant && this.currentVariant.available) {
        btn.disabled = false;
        btn.textContent = 'Adicionar ao carrinho';
      } else {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
      }
    }

    isOptionValueAvailable(optionIndex, value) {
      return this.product.variants.some(variant => {
        return variant.options[optionIndex] === value && variant.available;
      });
    }

    async addToCart() {
      if (!this.currentVariant) return;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: this.currentVariant.id,
            quantity: 1
          })
        });

        if (response.ok) {
          // Update cart count or show success message
          this.hidePopup();
          
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Optional: Show success message
          // alert('Product added to cart!');
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Error adding product to cart. Please try again.');
      }
    }

    formatPrice(price) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(price / 100);
    }

    renderError() {
      const content = document.getElementById('variantPopupContent');
      content.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <h2>Error Loading Product</h2>
          <p>Unable to load product options. Please try again.</p>
          <button class="close-btn" onclick="variantPopup.hidePopup()">×</button>
        </div>
      `;
    }
  }

  // Initialize the popup when page loads
  const variantPopup = new ShopifyVariantPopup();







// Function to check condition and update element visibility
function updateElementVisibility() {
    // Find the button and product form submit elements
    const button = document.querySelector('button.cellu-ultimate');
    const productFormSubmits = document.querySelectorAll('.product-form__submit');
    
    // Find all elements with class 'kaching-bundles__bar'
    const barElements = document.querySelectorAll('.kaching-bundles__bar');
    
    // Check if the second element (index 1) exists and has the 'selected' class
    const secondBar = barElements[2]; // nth-of-type(0) corresponds to index 1
    const hasSelectedClass = secondBar && secondBar.classList.contains('kaching-bundles__bar--selected');
    
    // Update button display
    if (button) {
        if (hasSelectedClass) {
            button.style.display = 'block';
        } else {
            button.style.display = 'none';
        }
    }
    
    // Update product-form__submit display
    productFormSubmits.forEach(element => {
        if (hasSelectedClass) {
            element.style.display = 'none';
        } else {
            element.style.display = ''; // Reset to default/inherit
        }
    });
}

// Initial check when script runs
updateElementVisibility();

// Set up MutationObserver to watch for class changes
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        // Check if the mutation affected class attributes
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Check if the changed element is one of our bar elements
            if (mutation.target.classList.contains('kaching-bundles__bar')) {
                updateElementVisibility();
            }
        }
        // Also check for added/removed nodes in case elements are dynamically added
        else if (mutation.type === 'childList') {
            updateElementVisibility();
        }
    });
});

// Start observing the document for changes
observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
});

// Optional: Also check periodically as a fallback (every 500ms)
setInterval(updateElementVisibility, 500);